import React from 'react'
import { IInnmaxMapInstance } from '../map.types'

const useWatchMap = <K extends keyof IInnmaxMapInstance>(
  targetRef: IInnmaxMapInstance,
  property: K
) => {
  const [value, setValue] = React.useState<IInnmaxMapInstance[K]>(
    targetRef[property]
  )

  React.useEffect(() => {
    if (!targetRef) {
      return
    }
    if (!targetRef.proxyHandler) {
      return
    }
    const _originalSet = targetRef.proxyHandler.set
    targetRef.proxyHandler.set = function (
      _target: any,
      _prop: any,
      _value: any,
      _receiver: any
    ) {
      _target[_prop] = _value
      if (_prop === property) {
        setValue(_value)
      }
      return _originalSet
        ? _originalSet(_target, _prop, _value, _receiver)
        : true
    }
    return () => {
      targetRef.proxyHandler.set = _originalSet
    }
  }, [targetRef, property])

  return value
}

export default useWatchMap
